import * as React from "react"

const SvgMegaphone = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="m11.477 13.774 4.643 2.806V6.329l-4.643 2.805H5.16a.78.78 0 0 0-.62.26.78.78 0 0 0-.26.62v2.88c0 .258.068.428.26.62s.363.26.62.26zm6.083-9.546a2 2 0 0 0-.178-.118q-.738-.432-1.458 0L10.92 7.134H5.16q-1.188 0-2.034.846a2.77 2.77 0 0 0-.846 2.034v2.88q0 1.188.846 2.034a2.77 2.77 0 0 0 2.034.846H6.6v4.32q0 .612.414 1.026t1.026.414 1.026-.414.414-1.026v-4.32h1.44l5.004 3.024q.72.432 1.458 0 .095-.055.178-.118.56-.42.56-1.142V5.37q0-.72-.56-1.142m2 2.402q.298.265.56.565.594.68 1.006 1.541.285.598.434 1.25a6.6 6.6 0 0 1 .16 1.468q0 .766-.16 1.47-.148.651-.434 1.248a6.8 6.8 0 0 1-1.006 1.541q-.262.3-.56.565z"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgMegaphone
